import {createAction} from '@reduxjs/toolkit';

import type {Channel} from '@mattermost/types/channels';
import type {Post} from '@mattermost/types/posts';

export const removePostsFromState = createAction<{
    postIds: Array<Post['id']>;
    channelId: Channel['id'];
}>('posts/actions/removePostsExceptChannel');
